import { HStack, Spacer, Stack, useBreakpointValue, Separator } from '@chakra-ui/react'
import type { FC } from 'react'

import DrawerHeaderActions from '@app/pages/strategies/components/drawer/drawerHeaderActions'
import { CardTitle } from '@app/shared/cards/components'
import { DomainObjectType } from '@app/shared/cards/components/cardTypeSection'
import FavoriteToggleButton from '@app/shared/favorites/favoriteToggleButton'
import { PageHeaderSection } from '@app/shared/layout'
import type { DomainStrategy } from '@app/types'
import ICON_MAP, { COLOR_MAP } from '@app/utils/iconMap'

interface Props {
  strategy: DomainStrategy
}

const Header: FC<Props> = ({ strategy }) => {
  const { id, favoriteId } = strategy

  return (
    <PageHeaderSection>
      <HStack pl={4}>
        <DomainObjectType
          type="Strategy"
          title="Strategy"
          icon={ICON_MAP.Strategy}
          color={COLOR_MAP.Strategy}
        ></DomainObjectType>
        <Spacer />
        <FavoriteToggleButton favoritableType="Strategy" favoritableId={id} favoriteId={favoriteId} />
        <DrawerHeaderActions objId={strategy.id} objType={strategy.classType} strategyId={id} />
      </HStack>
      <Separator />
      <Stack px={4}>
        <CardTitle domainObject={strategy} name="name" fontSize={useBreakpointValue({ base: 'lg', md: 'xl' })} />
      </Stack>
    </PageHeaderSection>
  )
}

export default Header
